import './select.scss';
import React, { FC, ReactNode } from 'react';
import classNames, { Argument } from 'classnames';
import Select from 'rc-select';
import { Size } from '../../../shared/types/size';
import { SelectProps } from 'rc-select/lib/generate';
import { OptionsType } from 'rc-select/lib/interface';
import { DefaultValueType } from 'rc-select/lib/interface/generator';
import { ChevronDown } from '@menuzen/icon/build/outline';

export interface ZenInputSelectProps extends Omit<SelectProps<OptionsType, DefaultValueType>, 'className'> {
    name?: string;
    options?: OptionsType;
    disabled?: boolean;
    className?: Argument;
    size?: Size;
    rounded?: Size;
    full?: boolean;
    showSearch?: boolean;
    optionFilterProp?: string;
    noBorder?: boolean;
    value?: DefaultValueType;
    prefix?: ReactNode;
}

const ZenInputSelect: FC<ZenInputSelectProps> = ({
    options,
    prefix,
    size,
    rounded,
    className,
    full = true,
    showSearch = false,
    optionFilterProp = 'label',
    noBorder = false,
    ...props
}) => {
    const classList = () => {
        return classNames([
            'flex border-grey-light focus-within:border-info items-center overflow-hidden',
            {
                border: !noBorder,
                [`zen-select-${size}`]: size,
                [`rounded-4`]: rounded === 'sm',
                [`rounded-10`]: rounded === 'md',
                [`rounded-15`]: rounded === 'lg',
                'zen-select-disabled': props.disabled,
            },
            className,
        ]);
    };

    const ArrowBottomIcon = () => {
        if (size === 'sm') {
            return (
                <span className={`text-10  text-primary-50`}>
                    <ChevronDown />
                </span>
            );
        } else if (size === 'xs') {
            return (
                <span className={`text-7  text-primary-50`}>
                    <ChevronDown />
                </span>
            );
        } else {
            return (
                <span className={`text-20 text-primary-50`}>
                    <ChevronDown />
                </span>
            );
        }
    };

    return (
        <div className={classList()}>
            {prefix}
            <Select
                prefixCls={`zen-select`}
                dropdownClassName={`zen-select-dropdown`}
                inputIcon={<ArrowBottomIcon />}
                className={full ? 'flex-1' : ''}
                menuItemSelectedIcon={``}
                value={props.value}
                options={options}
                showSearch={showSearch}
                optionFilterProp={optionFilterProp}
                {...props}
            />
        </div>
    );
};
export default ZenInputSelect;
